import { render } from "./QRCodeStyling.vue?vue&type=template&id=60660fd4&scoped=true"
import script from "./QRCodeStyling.vue?vue&type=script&lang=ts"
export * from "./QRCodeStyling.vue?vue&type=script&lang=ts"

import "./QRCodeStyling.vue?vue&type=style&index=0&id=60660fd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60660fd4"

export default script